import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=35f8f6e0&scoped=true&"
import script from "./LoginPage.vue?vue&type=script&lang=ts&"
export * from "./LoginPage.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=35f8f6e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f8f6e0",
  null
  
)

export default component.exports